import { useSelector } from "react-redux";
import InputSinNumber from "../../../components/input/InputSinNumber";
import ColOpcion from "../Calculos/renglonesCostos/ColOpcion";
import ColTitulo from "../Calculos/renglonesCostos/ColTitulo";
import RowCosto from "../Calculos/renglonesCostos/RowCosto";

export default function TotalMM() {
  const {
    totalMOpcion1,
    totalMOpcion2,
    totalMOpcion3,
    totalMOpcion4,
    totalMOpcion5,
  } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  return (
    <RowCosto>
      <ColTitulo>M (USD)</ColTitulo>
      <ColOpcion>
        <InputSinNumber value={totalMOpcion1} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={totalMOpcion2} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={totalMOpcion3} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={totalMOpcion4} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={totalMOpcion5} disabled />
      </ColOpcion>
    </RowCosto>
  );
}
